// extracted by mini-css-extract-plugin
module.exports = {"hero":"user_hero_1IU3L","featured":"user_featured_LprKe","featured__card":"user_featured__card_1mW3l","websites":"user_websites_10bkN","websites__card":"user_websites__card_x5xnt"};